import React from 'react'
import Form from '../../../form'
import Quote from '../../../quote'

const Igrolandia: React.FC = () => {
  return (
    <>
      <div className='onlinepbx__container'>

        <div className='onlinepbx__story'>
          <div className='onlinepbx__story__block__row onlinepbx__story__block__row__head onlinepbx__story__block__row__center'>
            <div className='onlinepbx__story__left onlinepbx__story__description'>
              <h2>
                Топ-4 способа использования телефонии в&nbsp;e-commerce
              </h2>
                <div className='onlinepbx__story__text onlinepbx__story__text__head'>
                  <div className='onlinepbx__story__text__paragraph'>
                  Онлайн-магазин игрушек &laquo;Игроландия&raquo; рассказал, как настроить телефонию, чтобы повысить эффективность менеджеров, увеличить количество обращений и&nbsp;продавать больше
                </div>
              </div>
              <div>
                <Form text='Попробовать onlinepbx' pageName='Истории' />
              </div>
            </div>
            <div className='onlinepbx__story__right onlinepbx__story__image'>
              <img src={process.env.PUBLIC_DIR + '/images/stories/story4-big.png'} />
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story2__block1'>
            <div>
              <h2 className='onlinepbx__content__header__center'>
                Основная проблема&nbsp;&mdash; огромная конкуренция
              </h2>
              <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
                <Quote width='922'>
                  <>
                    <div>Конкуренция среди онлайн-магазинов&nbsp;&mdash; настоящая битва, плюс мы&nbsp;работаем только с&nbsp;входящими звонками. Поэтому если клиент не&nbsp;дозвонился с&nbsp;первого раза, то&nbsp;он&nbsp;просто купит товар в&nbsp;другом месте.</div>
                    <div className='onlinepbx__quote__margin'>Когда открыли магазин и&nbsp;запустили продажи&nbsp;&mdash; решили сразу подключать телефонию. Выбрали onlinePBX, так как уже работали вместе по&nbsp;другим проектам. Функционал сервиса помогает оставаться прибыльной компанией, несмотря на&nbsp;конкурентов.</div>
                  </>
                </Quote>
              </div>
            </div>

            <div className='onlinepbx__story__block onlinepbx__story__block2'>
              <h2 className='onlinepbx__content__header__center'>
                Способы использования телефонии,<br/> которые приводят к&nbsp;нам клиентов
              </h2>
                <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center onlinepbx__story--no-padding-top'>
                  <div className='onlinepbx__story__left onlinepbx__story__description' >
                    <div className='onlinepbx__story__block__header'>1. Подключение автоперезвона</div>
                    <div className='onlinepbx__story__text'>
                      <div className='onlinepbx__story__text__paragraph'>
                        Настроили &laquo;автоперезвон по&nbsp;пропущенным&raquo;. В&nbsp;нашей сфере этот функционал имеет наибольшее значение. Благодаря ему, менеджеры не&nbsp;откладывают пропущенные на&nbsp;конец дня, а&nbsp;перезванивают клиенту в&nbsp;кратчайшее сроки.
                      </div>
                    </div>
                    <div className='onlinepbx__story__block__thumb'>
                      <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                      <div className='onlinepbx__story__text__medium'>
                        Клиенты не&nbsp;успевают уйти к&nbsp;конкурентам.
                      </div>
                    </div>
                  </div>
                  <div className='onlinepbx__story__right onlinepbx__story__image'>
                    <img src={process.env.PUBLIC_DIR + '/images/stories/story4-block1.jpg'} />
                  </div>
                </div>

                <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
                  <div className='onlinepbx__story__left onlinepbx__story__image'>
                  <img src={process.env.PUBLIC_DIR + '/images/stories/story4-block2.jpg'} />
                  </div>
                  <div className='onlinepbx__story__right onlinepbx__story__description' >
                    <div className='onlinepbx__story__block__header'>2. Настройка callback-виджета</div>
                    <div className='onlinepbx__story__text'>
                      <div className='onlinepbx__story__text__paragraph'>
                        Виджет отображается на&nbsp;сайте только в&nbsp;рабочее время. С&nbsp;помощью него мы&nbsp;собираем лиды и&nbsp;распределяем их&nbsp;между менеджерами.
                      </div>
                    </div>
                    <div className='onlinepbx__story__block__thumb'>
                      <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                      <div className='onlinepbx__story__text__medium'>
                        Лиды с&nbsp;сайта автоматически попадают к&nbsp;ответственному менеджеру.
                      </div>
                    </div>
                  </div>
                </div>

                <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
                  <div className='onlinepbx__story__left onlinepbx__story__description' >
                    <div className='onlinepbx__story__block__header'>3. Подключение голосового меню</div>
                    <div className='onlinepbx__story__text'>
                      <div className='onlinepbx__story__text__paragraph'>
                        Мы&nbsp;приветствуем клиентов и&nbsp;распределяем входящие звонки по&nbsp;отделам&nbsp;&mdash; так получилось разгрузить операторов и&nbsp;не&nbsp;создавать очередей.
                      </div>
                    </div>
                    <div className='onlinepbx__story__block__thumb'>
                      <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                      <div className='onlinepbx__story__text__medium'>
                        Повышается доверие и&nbsp;лояльность к&nbsp;компании.
                      </div>
                    </div>
                  </div>
                  <div className='onlinepbx__story__right onlinepbx__story__image'>
                    <img src={process.env.PUBLIC_DIR + '/images/stories/story4-block3.jpg'} />
                  </div>
                </div>

                <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
                  <div className='onlinepbx__story__left onlinepbx__story__image'>
                    <img src={process.env.PUBLIC_DIR + '/images/stories/story4-block4.jpg'} />
                  </div>
                  <div className='onlinepbx__story__right onlinepbx__story__description' >
                    <div className='onlinepbx__story__block__header'>4. Интеграция телефонии с&nbsp;amoCRM</div>
                    <div className='onlinepbx__story__text'>
                      <div className='onlinepbx__story__text__paragraph'>
                        Мы&nbsp;можем закреплять постоянных клиентов за&nbsp;менеджерами и&nbsp;не&nbsp;терять контактные данные и&nbsp;условия сделок.
                      </div>
                    </div>
                    <div className='onlinepbx__story__block__thumb'>
                      <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                      <div className='onlinepbx__story__text__medium'>
                        Клиенты довольны обслуживанием и&nbsp;возвращаются за&nbsp;покупками.
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story__block2 onlinepbx__story--mb'>
            <h2 className='onlinepbx__content__header__center'>
              В результате
            </h2>
            <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
              <Quote width='922'>
                <>
                  <div className='onlinepbx__quote__accent'>Мы&nbsp;принимаем порядка <span>200 звонков в&nbsp;день</span>, 70% обрабатываем сразу, по&nbsp;другим перезваниваем в&nbsp;ближайшее время.</div>
                  <div className='onlinepbx__quote__margin'>Отлаженная схема работы с&nbsp;входящими звонками выделяет нас среди конкурентов и&nbsp;покупатели возвращаются за&nbsp;новыми покупками благодаря отличному сервису.</div>
                </>
              </Quote>
            </div>
          </div>

        </div>

      </div>

      <div className='onlinepbx__story__block__form__wrapper'>
        <h2 className='onlinepbx__content__header__center'>
          Настроим сервис <span className='onlinepbx__content__header__green'>бесплатно</span> за 30 минут!
        </h2>
        <div className='onlinepbx__story__block__form'>
          <Form free isWhite text='Подключить бесплатно' pageName='Истории' />
        </div>
      </div>
    </>
  )
}

export default Igrolandia
